import { Pipe, PipeTransform } from '@angular/core';
import * as countries from 'i18n-iso-countries';
import csLocale from 'i18n-iso-countries/langs/cs.json';

@Pipe({
  name: 'localeCountryName',
  standalone: false
})
export class LocaleCountryNamePipe implements PipeTransform {

  public constructor() {
    countries.registerLocale(csLocale);
  }

  public transform(value: string | number | undefined | null): string {
    if(!value) {
      return '';
    } else {
      return countries.getName(value, 'cs') ?? '';
    }
  }

}
